import { changePosition } from './functions/changePosition';
import { generate } from './functions/generate';
import { removeDuplicated } from './functions/removeDuplicated';
import { updateOrPush } from './functions/updateOrPush';
Array.generate = generate;
Array.prototype.changePosition = changePosition;
Array.prototype.removeDuplicated = removeDuplicated;
Array.prototype.updateOrPush = updateOrPush;
export default {};
//# sourceMappingURL=index.js.map